<template>
  <div
    v-if="isIntro"
    class="dh-psy-byline dh-psy-byline--intro"
  >
    <div
      v-for="(item, idx) in items"
      :key="idx"
      v-html="item"
      :class="{'dh-psy-byline__item-wrapper': true,'dh-psy-byline__item-wrapper--first': idx === 0 }"
    />
  </div>
  <div
    v-else
    class="dh-psy-byline"
  >

    <div
      v-for="(item, idx) in items.slice(0,2)"
      :key="idx"
      v-html="item"
    />
    <button
      v-if="!clicked"
      ref="trigger"
      class="dh-psy-byline__trigger"
    >
      {{ hiddenPeopleCount }}+
    </button>
    <div
      hidden
      class="dh-psy-byline__body"
    >
      <div
        v-for="(item, idx) in items.slice(2)"
        :key="idx"
        v-html="item"
      />
    </div>
  </div>
</template>

<script>
import coreToggle from '@nrk/core-toggle' // Vanilla JS
import { globalEventStore } from '../../lib/global-event-store'

function getSeperator(idx, length) {
  if (idx === length - 1) return ''
  if (idx === length - 2) return ' og '
  return ', '
}
function formatPeople(people, isIntro, isFirst) {
  return (
    people &&
    people
      .map((item, idx) => {
        const seperator = getSeperator(idx, people.length)
        if (isIntro && isFirst && typeof item.value === 'string') {
          return ''
        } else if (typeof item.value === 'string') {
          return `<span class="dh-psy-byline__role">${item.value}: </span>`
        }

        const isIntroAuthor = isIntro && isFirst
        const prepend = isIntroAuthor && idx === 1 ? 'Av ' : ''
        const classNames = `dh-psy-byline__people${
          isIntroAuthor ? ' dh-psy-byline__people--intro-author' : ''
        }`
        if (item.value.mail) {
          return `<span class="${classNames}">${prepend}<a href="mailto:${
            item.value.mail
          }">${item.value.name.replace(/\s/g, '&nbsp;')}</a></span>${seperator}`
        }
        return `<span class="${classNames}">${prepend}${item.value.name.replace(
          /\s/g,
          '&nbsp;'
        )}</span>${seperator}`
      })
      .join('')
  )
}

export default {
  props: { isIntro: { type: Boolean, default: false } },
  data() {
    return {
      initialLength: 2,
      clicked: false
    }
  },
  computed: {
    hiddenPeopleCount() {
      return this.$root.$data.props.doc.byline.slice(this.initialLength).reduce((pv, item) => {
        return pv + item.value.length - 1
      }, 0)
    },
    items() {
      const byline = this.$root.$data.props.doc.byline

      if (!byline) return
      const raw = byline.map((item, idx) => {
        if (item.type === 'people') {
          const isFirst = idx === 0
          return Array.isArray(item.value)
            ? formatPeople(item.value, this.isIntro, isFirst)
            : item.value
        }
      })
      return raw
    }
  },
  mounted() {
    coreToggle(this.$refs.trigger)
    document.addEventListener('toggle', this.onToggle)
  },
  methods: {
    onToggle(e) {
      if (e.target === this.$refs.trigger) {
        document.removeEventListener('toggle', this.onToggle)
        this.clicked = true

        globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
          action: `TOGGLE_BYLINE`
        })
      }
    }
  }
}
</script>

<style scoped lang="postcss">
  .dh-psy-byline {
    position: relative;
    text-align: center;
    line-height: 1.8;
    font-size: 16px;
    font-size: 0.8em;
    font-size: 0.75em;
    font-size: 15px;
    width: 100%;
    max-width: 590px;
    box-sizing: border-box;
    margin: 0 auto 20px;
    padding: 18px 18px 26px;
    border-top: 1px solid #e9e9e9e9;
    border-bottom: 1px solid #e9e9e9e9;

    & :global(.dh-psy-byline__item-wrapper--first) {
      max-width: 80%;
      margin: auto;
      @media (min-width: 800px) {
        font-size: 18px;
      }
    }

    & :global(a) {
      &:hover {
        text-decoration: underline;
      }
    }

    & :global(.dh-psy-byline__role) {
      text-transform: uppercase;
      color: #777;
      font-weight: 600;
      font-size: 12px;
      font-size: 0.75em;
    }

    & .dh-psy-byline__trigger {
      background: #e9e9e9;
      color: #777;
      border-radius: 99px;
      appearance: none;
      border: none;
      font-weight: 600;
      width: 55px;
      line-height: 26px;
      font-size: 1em;
      position: absolute;
      bottom: -13px;
      left: calc(50% - 22.5px);
    }

    & .dh-psy-byline__body {
      max-height: 300px;
      transition: 0.5s max-height ease-in-out;
      overflow: hidden;

      &[hidden] {
        display: block;
        visibility: hidden;
        max-height: 0;
      }
    }
  }

  .dh-psy-byline--intro {
    margin: 0 auto;
    border-top: none;
    border-bottom: none;
    padding-top: 0;
    color: #ccc;

    & *:first-child {
      padding-bottom: 8px;
      padding-top: 30px;
      line-height: 1.5;

      @media (min-width: 800px) {
        padding-top: 0px;
        padding-bottom: 50px;
      }
    }

    & :global(.dh-psy-byline__people--intro-author) {
      color: #fff;
    }

    & :global(.dh-psy-byline__role) {
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.44);
      font-weight: 600;
      font-size: 12px;
      font-size: 0.75em;
    }
  }

  :global(.dh-psy-header-wrapper--white) {
    & .dh-psy-byline--intro {
      color: #545454;
      & :global(.dh-psy-byline__role) {
        color: rgba(57, 57, 57, 0.6);
      }

      & :global(.dh-psy-byline__people--intro-author) {
        color: #545454;
      }
    }
  }
</style>
